import React from 'react';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { CreateDisplayTemplatePageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { withFullScreenWithSummaryBar } from '@bingads-webui-react/app-layout-container';

import { notificationApi } from '../../adapters/get-notification';

const CreateDisplayTemplatePage = props => (<CreateDisplayTemplatePageComponent {...props} notificationApi={notificationApi} />);

const CreateDisplayTemplatePageWithLayout = withFullScreenWithSummaryBar(withInstrumentation(CreateDisplayTemplatePage));

export { CreateDisplayTemplatePageWithLayout as CreateDisplayTemplatePage };
